<template>
  <!--课程相关的面包屑-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item :to="pageNavObj.courseType === 'O' ? '/home/trainList' : '/home/eduList'">
      {{this.pageNavObj.courseType === 'O' ? '技术人员培训学习' : '技术人员宣贯学习'}}</el-breadcrumb-item>
    <el-breadcrumb-item :to="pageNavObj.courseType === 'O' ? `/home/trainDetail/${this.pageNavObj.courseId}` : `/home/eduDetail/${this.pageNavObj.courseId}`">
      {{pageNavObj.courseName}}</el-breadcrumb-item>
    <el-breadcrumb-item v-if="pageNavObj.sectionTitle">{{pageNavObj.sectionTitle}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
  export default {
    name: "PageNav",
    props: {
      pageNavObj: Object,
    }
  }
</script>

<style lang="scss" scoped>
  .el-breadcrumb {
    margin-bottom: 15px
  }
</style>
